
export default {
  'en': {

  }
};
